module.exports = __webpack_public_path__ + "images/The Possibilities of Ad Hoc Decentralised Digital Infrastructure.pdf?v=d17fd4139bbc02894bba653eb88080a9";